import { g } from '@pretto/bricks/components/layout'
import * as typo from '@pretto/bricks/core/typography'
import Tooltip from '@pretto/bricks/components/utility/Tooltip'
import { QuestionMarkCircleBold } from '@pretto/picto'
import styled from 'styled-components'

export const Label = styled.div`
  ${typo.headline16};
  display: flex;
  align-items: center;
`
export const LabelTooltip = styled(Tooltip).attrs({ isOneLiner: false })`
  margin-left: ${g(1)};
  cursor: help;
  display: flex;
`
export const Picto = styled(QuestionMarkCircleBold)`
  opacity: 0.3;
`
export const TooltipContent = styled.div`
  ${typo.bodyMedium16};
  width: ${g(26)};
  text-align: center;
  text-transform: initial;
`
